import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { qualificationFields } from '../../api/applicationData';

const Qualifications = forwardRef(({ newApplicant, setNewApplicant }, ref) => {
  const [errors, setErrors] = useState({});

  useImperativeHandle(ref, () => ({
    validateForm: () => {
      const newErrors = {};
      qualificationFields.forEach(({ key }) => {
        if (newApplicant?.qualifications?.[key] === null) {
          newErrors[key] = 'This field is required';
        }
      });
      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
    },
  }));

  const handleChange = (key, value) => {
    setNewApplicant((prev) => ({
      ...prev,
      qualifications: {
        ...prev.qualifications,
        [key]: value,
      },
    }));
    setErrors((prev) => ({ ...prev, [key]: '' }));
  };

  return (
    <div className="space-y-3">
      {qualificationFields.map(({ key, label }) => (
        <div className={`rounded-lg px-5 py-2 bg-portal-100 border`} key={key}>
          <div className="md:flex justify-between space-x-5 items-center">
            <div className="flex-1 text-sm">{label}</div>
            <div className="flex sm:justify-center space-x-4 mt-3 md:mt-0">
              <label
                className={
                  'flex items-center border-2 rounded px-1.5 py-0.5' +
                  (errors[key] ? ' border-red-500' : '')
                }>
                <input
                  type="checkbox"
                  className="form-checkbox"
                  checked={newApplicant?.qualifications?.[key] === true}
                  onChange={() => handleChange(key, true)}
                />
                <span className="text-sm ml-2">Yes</span>
              </label>
              <label
                className={
                  'flex items-center border-2 rounded px-1.5 py-0.5' +
                  (errors[key] ? ' border-red-500' : '')
                }>
                <input
                  type="checkbox"
                  className="form-checkbox"
                  checked={newApplicant?.qualifications?.[key] === false}
                  onChange={() => handleChange(key, false)}
                />
                <span className="text-sm ml-2">No</span>
              </label>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
});

export default Qualifications;
